
export default "/assets/divide-micro.d3f0e688.svg"